import clientFactory from "../factories/http_client";
import {API} from "../api/api";

class ScenarioCommentService {

	/** @return  Promise<AxiosResponse<T>> */
	get = (projectId, scenarioId, commentId) => {
		return clientFactory.client(API.data.scope)
		                    .request({
			                             method: API.data.projects.id.scenarios.id.comments.id.method,
			                             url: API.data.projects.id.scenarios.id.comments.id.url(projectId, scenarioId, commentId)
		                             });
	};

	/** @return  Promise<AxiosResponse<T>> */
	create = (projectId, scenarioId, comment) => {
		return clientFactory.client(API.data.scope)
		                    .request({
			                             method: API.data.projects.id.scenarios.id.comments.create.method,
			                             url: API.data.projects.id.scenarios.id.comments.create.url(projectId, scenarioId),
			                             data: API.data.projects.id.scenarios.id.comments.create.build(comment),
			                             headers: {
				                             'Content-Type': 'application/json',
			                             }
		                             });
	};

	/** @return  Promise<AxiosResponse<T>> */
	save = (projectId, scenarioId, comment) => {
		return clientFactory.client(API.data.scope)
		                    .request({
			                             method: API.data.projects.id.scenarios.id.comments.save.method,
			                             url: API.data.projects.id.scenarios.id.comments.save.url(projectId, scenarioId),
			                             data: API.data.projects.id.scenarios.id.comments.save.build(comment),
			                             headers: {
				                             'Content-Type': 'application/json',
			                             }
		                             });
	};

	/** @return  Promise<AxiosResponse<T>> */
	delete = (projectId, scenarioId, commentId) => {
		return clientFactory.client(API.data.scope)
		                    .request({
			                             method: API.data.projects.id.scenarios.id.comments.delete.method,
			                             url: API.data.projects.id.scenarios.id.comments.delete.url(projectId, scenarioId),
			                             data: API.data.projects.id.scenarios.id.comments.delete.build(commentId),
		                             });
	};
}

export default ScenarioCommentService